var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { transient, autoinject, observable } from "aurelia-framework";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { LotteryClientService } from "../../../../services/modules/lottery-client.service";
import { WinSimulationClientService } from "../../../../services/modules/win-simulation-client.service";
import { LotteryModel } from "../../../../models/modules/lotteryplatofrm.models";
var WinSimulation = /** @class */ (function () {
    function WinSimulation(notificationClientService, lotteryClientService, winSimulationClientService, router) {
        this.notificationClientService = notificationClientService;
        this.lotteryClientService = lotteryClientService;
        this.winSimulationClientService = winSimulationClientService;
        this.router = router;
        this.lotteries = [];
        this.mainNumbers = [];
        this.bonusNumbers = [];
    }
    WinSimulation.prototype.activate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lotteries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.lotteryClientService.getLotteries()];
                    case 1:
                        lotteries = _a.sent();
                        this.lotteries = (lotteries || []).sort(function (a, b) { return a.name.localeCompare(b.name); });
                        return [2 /*return*/];
                }
            });
        });
    };
    WinSimulation.prototype.selectedLotteryChanged = function (newVal) {
        if (!newVal) {
            this.info = null;
            this.mainNumbers = [];
            this.bonusNumbers = [];
            return;
        }
        this.loadInfo(newVal.lotteryId);
    };
    WinSimulation.prototype.loadInfo = function (lotteryId) {
        var _this = this;
        this.loadingInfo = true;
        this.info = null;
        this.winSimulationClientService.getInfo(lotteryId).then(function (info) {
            _this.loadingInfo = false;
            _this.info = info;
            if (info.currentSimulation) {
                _this.mainNumbers = __spreadArray([], __read(info.currentSimulation.mainNumbers), false);
                _this.bonusNumbers = __spreadArray([], __read(info.currentSimulation.bonusNumbers), false);
            }
            else {
                _this.mainNumbers = new Array(info.mainNumbersCount).fill(null);
                _this.bonusNumbers = info.bonusNumbersCount > 0 ? new Array(info.bonusNumbersCount).fill(null) : [];
            }
        }, function () {
            _this.loadingInfo = false;
            _this.notificationClientService.show("Error", "Failed to load simulation info", NotificationType.Error);
        });
    };
    Object.defineProperty(WinSimulation.prototype, "isActive", {
        get: function () {
            return this.info && this.info.currentSimulation ? this.info.currentSimulation.isActive : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WinSimulation.prototype, "canSave", {
        get: function () {
            return !!this.info && !this.saving && !this.toggling && !this.deleting
                && this.mainNumbers.length > 0
                && this.mainNumbers.every(function (n) { return n != null && n !== undefined; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WinSimulation.prototype, "canToggle", {
        get: function () {
            return !!this.info && !!this.info.currentSimulation && !this.toggling && !this.saving && !this.deleting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WinSimulation.prototype, "canDelete", {
        get: function () {
            return !!this.info && !!this.info.currentSimulation && !this.deleting && !this.saving && !this.toggling;
        },
        enumerable: false,
        configurable: true
    });
    WinSimulation.prototype.save = function () {
        var _this = this;
        if (!this.canSave)
            return;
        this.saving = true;
        this.winSimulationClientService.set({
            lotteryId: this.info.lotteryId,
            mainNumbers: this.mainNumbers.map(Number),
            bonusNumbers: this.bonusNumbers.map(Number)
        }).then(function (response) {
            _this.saving = false;
            if (response.success) {
                _this.notificationClientService.show("Saved", "Win simulation saved", NotificationType.Success);
                _this.loadInfo(_this.info.lotteryId);
            }
            else {
                _this.notificationClientService.show("Error", response.error || "Failed to save simulation", NotificationType.Error);
            }
        }, function () {
            _this.saving = false;
            _this.notificationClientService.show("Error", "Request failed", NotificationType.Error);
        });
    };
    WinSimulation.prototype.toggle = function () {
        var _this = this;
        if (!this.canToggle)
            return;
        var newActive = !this.isActive;
        this.toggling = true;
        this.winSimulationClientService.toggle(this.info.lotteryId, newActive).then(function () {
            _this.toggling = false;
            _this.info.currentSimulation.isActive = newActive;
        }, function () {
            _this.toggling = false;
            _this.notificationClientService.show("Error", "Failed to toggle simulation", NotificationType.Error);
        });
    };
    WinSimulation.prototype.deleteSimulation = function () {
        var _this = this;
        if (!this.canDelete)
            return;
        this.deleting = true;
        this.winSimulationClientService.deleteSimulation(this.info.lotteryId).then(function () {
            _this.deleting = false;
            _this.notificationClientService.show("Deleted", "Win simulation deleted", NotificationType.Success);
            _this.info.currentSimulation = null;
            _this.mainNumbers = new Array(_this.info.mainNumbersCount).fill(null);
            _this.bonusNumbers = _this.info.bonusNumbersCount > 0 ? new Array(_this.info.bonusNumbersCount).fill(null) : [];
        }, function () {
            _this.deleting = false;
            _this.notificationClientService.show("Error", "Failed to delete simulation", NotificationType.Error);
        });
    };
    WinSimulation.prototype.goBack = function () {
        this.router.navigateBack();
    };
    __decorate([
        observable,
        __metadata("design:type", LotteryModel)
    ], WinSimulation.prototype, "selectedLottery", void 0);
    WinSimulation = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            LotteryClientService,
            WinSimulationClientService,
            Router])
    ], WinSimulation);
    return WinSimulation;
}());
export { WinSimulation };
